import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { BankPortalService, CardPaymentServiceData, FonePayPaymentServiceData, ImarkTerminalAddCommands, MerchantConfigurationVM, MerchantMasterService, NepalPayPaymentServiceData } from '../../../../web-api-client';

@Component({
  selector: 'merchants-cardfonepayandnepalpay',
  templateUrl: './merchants-cardfonepayandnepalpay.component.html',
  styleUrls: ['../merchants.component.css']
})

export class MerchantsCardFonepayAndNepalpayComponent implements OnInit {

  @Input('deploymentRequestId') deploymentRequestId: any;
  @Input('configuractionClicked') configuractionClicked: boolean = false;
  @Input('merchantConfiguration') merchantConfiguration: MerchantConfigurationVM = new MerchantConfigurationVM();
  @Output('call-back-output') callBackOutput: EventEmitter<object> = new EventEmitter();

  cardTerminalAddForm!: FormGroup;
  fonePayTerminalAddForm!: FormGroup;
  nepalPayTerminalAddForm!: FormGroup;
  submitted: boolean = false;
  cardTerminalDetails = new CardPaymentServiceData();
  terminalDetails = new ImarkTerminalAddCommands();
  fonepayTerminalDetails = new FonePayPaymentServiceData();
  nepalpayTerminalDetails = new NepalPayPaymentServiceData();
  paymentschemeTypes = [
    { value: 1, option: "CARD" },
    { value: 2, option: "NEPALPAY" },
    { value: 3, option: "FONEPAY" },
  ];

  currency: Array<any> = [
    { text: 'NPR' },
    { text: 'USD' }

  ];

  constructor(private _bankPortalService: BankPortalService,
    private formBuilder: FormBuilder,
    private _toastr: ToastrService) {
  }

  ngOnInit(): void {
    console.log(this.merchantConfiguration);
    this.cardTerminalAddForm = this.formBuilder.group({
      terminalId: [this.merchantConfiguration?.idTerminal || '', [Validators.required, Validators.pattern('^[0-9]{8,8}$')]],
      merchantId: [this.merchantConfiguration.idMerchant || '', [Validators.required, Validators.pattern('^[0-9]{15,15}$')]],
      currency: ["NPR", Validators.required],
      cashAdvance: [this.merchantConfiguration.cashAdvance || '', [Validators.required]],
      tipAdjustment: [this.merchantConfiguration.tipAdjustment || '', [Validators.required]],
      preAuthorization: [this.merchantConfiguration.preAuthorization || '', [Validators.required]],
      manualTransaction: [this.merchantConfiguration.manualTransaction || '', [Validators.required]],
      paymentScheme: [1],
    });
    this.fonePayTerminalAddForm = this.formBuilder.group({
      terminalId: ['', Validators.required],
      merchantId: ['', Validators.required],
      currency: ["NPR", Validators.required],
      merchantCategoryCode: ['', Validators.required],
      merchantCode: ['', Validators.required],
      secretKey: ['', Validators.required],
      paymentScheme: [2],
    });
    this.nepalPayTerminalAddForm = this.formBuilder.group({
      terminalId: ['', Validators.required],
      merchantId: ['', Validators.required],
      currency: ["NPR", Validators.required],
      paymentScheme: [3],
      merchantStatus: ['', Validators.required],
      merchantPanNumber: ['', Validators.required],
      merchantAddress: ['', Validators.required],
      merchantName: ['', Validators.required],
      acquirerInstrument: ['', Validators.required],
      merchantCategoryCode: ['', Validators.required],
    });
    // this.setCardTerminalForm();
  }

  get card(): { [key: string]: AbstractControl } {
    return this.cardTerminalAddForm.controls;
  }

  get fonePay(): { [key: string]: AbstractControl } {
    return this.fonePayTerminalAddForm.controls;
  }
  get nepalPay(): { [key: string]: AbstractControl } {
    return this.nepalPayTerminalAddForm.controls;
  }

  setCardTerminalForm() {
    if (this.merchantConfiguration) {
      this.cardTerminalAddForm.get('terminalId')?.setValue(this.merchantConfiguration.idTerminal);
      this.cardTerminalAddForm.get('merchantId')?.setValue(this.merchantConfiguration.idMerchant);
      this.cardTerminalAddForm.get('currency')?.setValue(this.merchantConfiguration.currency);
      this.cardTerminalAddForm.get('cashAdvance')?.setValue(this.merchantConfiguration.cashAdvance);
      this.cardTerminalAddForm.get('tipAdjustment')?.setValue(this.merchantConfiguration.tipAdjustment);
      this.cardTerminalAddForm.get('preAuthorization')?.setValue(this.merchantConfiguration.preAuthorization);
      this.cardTerminalAddForm.get('manualTransaction')?.setValue(this.merchantConfiguration.manualTransaction);
    }
  }
  unSuccess(error) {
    //error goes here
  }
  onSubmitTerminalAddForm() {
    this.onSubmitCardterminalAddForm();
    this.onSubmitFonePayterminalAddForm();
    this.onSubmitNepalPayterminalAddForm();
    this.terminalDetails.deploymentRequestId = this.deploymentRequestId;
    this.terminalDetails.paymentProviderData = this.cardTerminalDetails;
    this.terminalDetails.fonepayPaymentData = this.fonepayTerminalDetails;
    this.terminalDetails.nepalpayPaymentData = this.nepalpayTerminalDetails;
    const terminalDetails = ImarkTerminalAddCommands.fromJS(this.terminalDetails);
    this._bankPortalService.bankPortal_ImarkTerminalAdd(terminalDetails).subscribe(
      res => {
        this._toastr.show("Updated Successfully", "Success")
      },
      err => {
        this._toastr.show("Failed to Update", "Error")
      }
    );

  }
  onSubmitCardterminalAddForm() {
    this.submitted = true;
    if (this.cardTerminalAddForm.invalid) {
      return;
    }
    this.cardTerminalDetails = this.cardTerminalAddForm.value;
  }
  onSubmitFonePayterminalAddForm() {
    this.submitted = true;
    if (this.fonePayTerminalAddForm.invalid) {
      return;
    }
    this.fonepayTerminalDetails = this.fonePayTerminalAddForm.value;
  }

  onSubmitNepalPayterminalAddForm() {
    this.submitted = true;
    if (this.nepalPayTerminalAddForm.invalid) {
      return;
    }
    this.nepalpayTerminalDetails = this.nepalPayTerminalAddForm.value;

  }

}